import React, { useMemo } from 'react';

const formatCurrency = (value) => {
  if (value == null || value === '') return '$0';
  return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', maximumFractionDigits: 0 }).format(value);
};

const FundingCommissionMetrics = ({ commissions }) => {
  const metrics = useMemo(() => {
    const sum = (items, predicate) => items
      .filter(predicate)
      .reduce((total, item) => total + (Number(item.commissionAmount) || 0), 0);

    const clawback = commissions.filter(
      (item) => ['Low', 'Medium', 'High'].includes(item.clawbackRisk)
        && !['Void', 'Paid', 'Reversed'].includes(item.status),
    );

    return [
      { label: 'Projected', value: formatCurrency(sum(commissions, (c) => c.status === 'Projected')) },
      { label: 'Earned', value: formatCurrency(sum(commissions, (c) => c.status === 'Earned')) },
      { label: 'Pending payout', value: formatCurrency(sum(commissions, (c) => c.status === 'Pending Payout')) },
      { label: 'Paid', value: formatCurrency(sum(commissions, (c) => c.status === 'Paid')) },
      { label: 'Clawback risk', value: formatCurrency(clawback.reduce((total, item) => total + (Number(item.commissionAmount) || 0), 0)) },
      { label: 'Reversed', value: formatCurrency(sum(commissions, (c) => c.status === 'Reversed')) },
    ];
  }, [commissions]);

  return (
    <div className="grid gap-3 sm:grid-cols-2 xl:grid-cols-3">
      {metrics.map((metric) => (
        <div key={metric.label} className="rounded-xl border border-[var(--fg-line)] bg-[var(--fg-panel-soft)] px-4 py-3">
          <div className="text-xs font-semibold uppercase tracking-wide text-[var(--fg-muted)]">{metric.label}</div>
          <div className="mt-1 text-lg font-bold text-[var(--fg-text)]">{metric.value}</div>
        </div>
      ))}
    </div>
  );
};

export default FundingCommissionMetrics;
